import { Component, OnDestroy, OnInit } from "@angular/core";
import { AuthService } from "@services/api/auth.service";
import { Router } from "@angular/router";
import { UserService } from "@services/user.service";
import { User } from "@models/user";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "npi-main-layout",
    templateUrl: "main.layout.html",
    styleUrls: ["./main.layout.scss"],
    standalone: false
})
export class MainLayout implements OnInit, OnDestroy {
  public navItems: { name: string; path: string }[];
  public user: User;
  private destroy = new Subject();

  constructor(private authService: AuthService, private router: Router, private userService: UserService) {
    this.setNavItems();
  }

  ngOnInit() {
    this.userService
      .getUser()
      .pipe(takeUntil(this.destroy))
      .subscribe((user) => {
        if (user) {
          this.user = user;
        }
      });
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.complete();
  }

  public logout(): void {
    this.authService.logout().subscribe(() => {
      this.router.navigate(["/login"]);
    });
  }

  private setNavItems(): void {
    this.navItems = [
      {
        name: "Planning",
        path: "/planning",
      },
      {
        name: "Status",
        path: "/status",
      },
      {
        name: "Gebruikers",
        path: "/users",
      },
    ];
  }
}
